import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import { MtnaTrackByPropertyPipeModule } from '@mtna/lib-ui';

import { RdsChipsComponent } from './chips.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MatButtonModule, MatChipsModule, MatIconModule, MtnaTrackByPropertyPipeModule, DragDropModule],
  exports: [RdsChipsComponent],
  declarations: [RdsChipsComponent],
  providers: []
})
export class RdsChipsModule {}

export * from './chips.component';
